import React, { useContext, useState } from "react";
import { RegisterForm } from "~/assets/js/components/Forms/modules";
import Success from "./Success";
import { CheckoutContext, ACTIONS, PAGES } from "../../CheckoutProvider";
import { AddToast } from "~/assets/js/components/Toast";
import i18next from "i18next";

const Register = () => {
    const [success, setSuccess] = useState(false);
    const { dispatch } = useContext(CheckoutContext);
    const handleOnSubmitResponse = (response) => {
        if (!response.ok) {
            return dispatch(
                AddToast("danger", i18next.t("toasts.register.error"))
            );
        }

        dispatch({ type: ACTIONS.LOGIN, payload: response.user });
        setSuccess(true);
    };

    const moveToNextPage = () => {
        return dispatch({
            type: ACTIONS.CHANGE_PAGE,
            payload: PAGES.CONTACT_DETAILS,
        });
    };

    if (success) {
        window.scrollTo(0, 0);
        return <Success onContinueClick={moveToNextPage} />;
    }

    return (
        <div style={{ maxWidth: "440px", margin: "0 auto" }}>
            <RegisterForm onSubmitResponse={handleOnSubmitResponse} />
        </div>
    );
};

export default Register;
